<template>
    <div class="pinlock" :class="{'locked' : isLocked }">
        <div class="pinlock__wrapper">
            <IconCloseWhite class="pinlock__close close" @click="closeHandle"></IconCloseWhite>

            <div class="pinlock__avatar">
                <IconParent class="pinlock__avatar-icon"></IconParent>
                <span class="pinlock__avatar-name">Rodzic</span>
            </div>

            <div class="pinlock__header">
                <IconSpeakerWhite class="pinlock__speaker" @click="speechSynthesis(text)"></IconSpeakerWhite>
                <p class="pinlock__title">{{ text }}</p>
            </div>

            <span class="pinlock__subtitle">Aby kontynować wpisz pin - dostęp tylko dla rodziców</span>

            <div class="pinlock__pin">
                <div class="pinlock__pin-inputs">
                    <input class="pinlock__pin-input" type="password" maxlength="1" v-model="pinArray[0]" id="pin1" @keyup="focusHandle" @keypress="isNumber">
                    <input class="pinlock__pin-input" type="password" maxlength="1" v-model="pinArray[1]" id="pin2" @keyup="focusHandle" @keypress="isNumber">
                    <input class="pinlock__pin-input" type="password" maxlength="1" v-model="pinArray[2]" id="pin3" @keyup="focusHandle" @keypress="isNumber">
                    <input class="pinlock__pin-input" type="password" maxlength="1" v-model="pinArray[3]" id="pin4" @keyup="focusHandle" @keypress="isNumber">

                    <div class="pinlock__pin-remove" @click="removeHandle"><IconClose></IconClose></div>
                </div>

                <div class="pinlock__pin-numbers">
                    <span class="pinlock__pin-number" v-for="(n, index) in 9" @click="numberHandle(index+1)" :key="index">{{ index + 1}}</span>
                </div>

                <button class="pinlock__remind" @click="remindHandle"><span>Przypomnij PIN</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import IconClose from "../elements/icons/IconClose";
import IconCloseWhite from "../elements/icons/IconCloseWhite";
import IconParent from "../elements/icons/IconParent";
import IconSpeakerWhite from "../elements/icons/IconSpeakerWhite";
import { useToast } from "vue-toastification";
import { subprofileUnselect } from '../../mixins/subprofileUnselect';
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();
const toast = useToast()

export default {
    name: "PinLock",
    data() {
        return {
            CHECK_PIN: ' /api/account/user-application-data/pin-check?device=www',
            FAVORITE_ADD: '/api/krainaabc/subprofile/favorite-add?device=www',
            showModal: false,
            wrongPinCounter: 0,
            pinArray: ['', '', '', ''],
            isLocked: false,
            text: 'Tylko dla rodziców'
        };
    },
    mixins: [subprofileUnselect],
    components: {
        IconClose,
        IconCloseWhite,
        IconParent,
        IconSpeakerWhite
    },
    watch: {
        pin(value) {
            if(value && value.length === 4) {
                this.checkPin();
            }
        },
        wrongPinCounter(value) {
            if(value && value === 3) {
                this.isLocked = true;
                cookies.set("parent_lock", "7d");
            }
        }
    },
    computed: {
        inputs() {
            return document.getElementsByClassName("pinlock__pin-input");
        },
        pin() {
            return this.pinArray.join("");
        },
        getPinLock() {
            return this.$store.getters.getPinLock;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        getPinLockChild() {
            return this.$store.getters.getPinLockChild;
        }     
    },
    methods: {
        isNumber(e) {
            if ((!/[1-9]/.test(e.key) && e.key !== 'Backspace') || (e.target.value.length === 4 && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        },
        focusHandle(e) {
            const char = String.fromCharCode(e.keyCode);

            if(/[1-9]/.test(char) && e.target.nextElementSibling) {
                e.target.nextElementSibling.focus();
            }
            
            if(e.key === "Backspace" && !e.target.value && e.target.previousElementSibling) {
                e.target.previousElementSibling.focus();
            }
        },
        numberHandle(number) {
            if(!this.isLocked) {
                for (let i = 0; i < this.pinArray.length; i++) {
                    if(this.pinArray[i] === '') {
                        this.pinArray[i] = number;
                        this.inputs[i+1] ? this.inputs[i+1].focus() : '';
                        break
                    }
                }
            }
        },
        removeHandle() {
            if(!this.isLocked) {
                for (var i = this.pinArray.length - 1; i >= 0; i--) {
                    if(this.pinArray[i]) {
                        this.pinArray[i] = '';
                        this.inputs[i].focus();
                        break
                    } else {
                        if(i === 0) {
                            this.inputs[0].focus();
                        }
                    }
                }
            }
        },
        checkPin() {
            let data = {};
            data['src'] = 'krainaabc';
            data['pin'] = this.pin;

            axios
                .post(this.CHECK_PIN, data)
                .then(() => { 
                    if(this.getPinLock.mode === 'unlock') { // jeśli mode unlock odblokuj materiał
                        this.addFavorite();
                    } else if(this.getPinLock.mode === 'remind') { // jeśli mode remind ukryj płachtę
                        this.$store.dispatch("changePinLock", { mode: this.getPinLock.mode });
                        
                        if(this.getPinLockChild && this.getPinLockChild.subProfile && this.getPinLockChild.subProfile._id) {
                            this.$store.dispatch("changePinLockChild", { mode: 'remind', subProfile: this.getPinLockChild.subProfile });
                        }
                    } else if(this.getPinLock.mode === 'timeExtend') {
                        this.$store.dispatch("changePinLock", {isOpen: false, mode: 'timeExtend'});
                    } else { // w przeciwnym wypadku, przenieś do strefy rodzica i ukryj płachtę
                        if(this.getPinLock.path) {
                            this.$router.push({
                                path: this.getPinLock.path
                            });                        
                        }
                        // toast.success("Odblokowano");
                        this.$store.dispatch("changePinLock", {});
                        document.body.classList.remove("backdrop");
                        subprofileUnselect();
                    }
                })           
                .catch(() => {
                    this.wrongPinCounter++;
                    toast.error("Błędny PIN");
                });          
        },
        addFavorite() {
            const data = {};
            data['src'] = 'krainaabc';
            data['id'] = this.getPinLock.id;
            data['subProfile_id'] = this.activeSubProfile._id;

            axios
                .post(this.FAVORITE_ADD, data)
                .then(() => {
                    toast.success("Odblokowano i dodano do ulubionych");
                    this.$store.dispatch("changePinLock", { mode: this.getPinLock.mode });
                    this.$store.dispatch("activeSubProfile");   
                    this.$store.dispatch("changeModalUnlock", false);
                    this.$store.dispatch("changeModalBackdrop", false);
                })
                .catch(() => {
                    toast.error("Odblokowanie i dodanie do ulubionych nie powiodło się");
                }); 
        },
        remindHandle() {
            this.$store.dispatch("changePinLock", { isOpen: true, path: this.getPinLock.path, mode: 'remind'});
            this.$store.dispatch("changeModalLoginState");
            this.$store.dispatch("changeModalBackdrop", true);    
        },
        closeHandle() {
            this.$store.dispatch("changePinLock", {});
            document.body.classList.remove("backdrop");
            // this.$store.dispatch("activeSubProfile");  

            if(this.getPinLockChild && this.getPinLockChild.subProfile && this.getPinLockChild.subProfile._id) {
                this.$store.dispatch("changePinLockChild", { mode: 'unlock', subProfile: this.getPinLockChild.subProfile });
            }            
        }
    },
    mounted() {
        document.body.classList.add("backdrop");

        if(this.inputs) {
            this.inputs[0].focus();
        }

        if(cookies.isKey("parent_lock")) {
            this.isLocked = true;
        }
    }
};
</script>
